module.exports = __webpack_public_path__ + "static/img/Gold.a360209.png";


//////////////////
// WEBPACK FOOTER
// ./static/banners/Gold.png
// module id = 2237
// module chunks = 61